<template>
  <v-container fill-height class="pa-0">
    <v-layout align-center justify-center>
      <v-snackbar
        v-model="snackbar"
        :color="textError ? 'error' : color"
        :multi-line="mode === 'multi-line'"
        top="top"
        >{{ textError ? textError : text }}</v-snackbar
      >
      <v-flex xs12 sm8 md4>
        <div class="flex d-flex justify-center">
          <div class="">
            <div class="layer">
              <h2>Aplicativo para la gestión del sistema de calidad</h2>
            </div>
          </div>
        </div>
        <v-form class="mt-10" ref="form" v-model="valid" lazy-validation>
          <v-text-field
            name="email"
            label="Email"
            type="email"
            v-model="email"
            :rules="emailRules"
            required
            outlined
          ></v-text-field>
          <v-text-field
            name="password"
            label="Contraseña"
            id="password"
            :type="show ? 'text' : 'password'"
            required
            v-model="password"
            :rules="passwordRules"
            outlined
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show = !show"
            @keyup.enter="submit"
          ></v-text-field>
          <!-- Reset Password modal-->
          <!-- <div class="text-left mb-5">
            <v-dialog v-model="dialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <span color="red lighten-2" dark v-bind="attrs" v-on="on"
                  >He olvidado la contraseña</span
                >
              </template>

              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title
                  >Contraseña olvidada</v-card-title
                >

                <v-card-text>
                  <h3 class="mb-5 mt-5">
                    Ingrese su dirección de correo electrónico a continuación y
                    le enviaremos información para recuperar su cuenta.
                  </h3>
                  <v-form ref="formReset" v-model="validReset" lazy-validation>
                    <v-text-field
                      outlined
                      name="email"
                      label="Email"
                      type="email"
                      v-model="emailResetPwd"
                      :rules="emailResetPwdRules"
                      required
                    ></v-text-field>
                  </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn
                    class="grey darken-4 white--text"
                    :disabled="!validReset"
                    @click="submitReset"
                  >
                    restablecer la contraseña
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog = false"
                    >Cerrar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div> -->
        </v-form>
        <v-flex class="d-flex justify-center">
          <v-btn
            class="login__btn white--text"
            color="primary"
            :disabled="!valid || loading"
            :loading="loading"
            @click="submit"
            >Login</v-btn
          >
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      show: false,
      loading: false,
      color: "success",
      mode: "",
      snackbar: false,
      text: "Se le ha enviado un correo electrónico. Por favor revise y siga las instrucciones.",
      textError: null,
      timeout: 3000,
      x: null,
      y: "top",
      dialog: false,
      valid: false,
      validReset: false,
      email: "",
      password: "",
      emailResetPwd: "",
      emailRules: [
        (v) => !!v || "Campo requerido",
        (v) => /.+@.+/.test(v) || "Campo requerido",
      ],
      emailResetPwdRules: [
        (v) => !!v || "Campo requerido",
        (v) => /.+@.+/.test(v) || "Campo requerido",
      ],
      passwordRules: [(v) => !!v || "Campo requerido"],
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "errorMessage"]),
  },
  methods: {
    ...mapActions(["userLogin"]),
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let done = await this.userLogin({
            email: this.email,
            password: this.password,
          });
          if (done) {
            this.textError = null;
          }
          //console.log("good");
        } catch (error) {
          //console.log("Catsh");
          this.textError = this.errorMessage;
          this.loading = false;
          this.snackbar = true;
          setTimeout(() => {
            this.snackbar = false;
          }, 3000);
        }
      }
    },
    async submitReset() {
      if (this.$refs.formReset.validate()) {
        //console.log("Reset");
      }
    },
  },
  beforeCreate() {
    this.$router.push("/");
  },
};
</script>
<style scoped>
.circle {
  margin-top: 25px;
  border-radius: 50%;
  background-color: #ffffff;
  height: 200px;
  width: 200px;
  background-image: url("../assets/023TRA_TRAM LOGO RGB_TRAM LOGO POSITIVO.png");
  background-position: 50%;
  background-size: contain;
}

.layer {
  /* background-color: #1436528c; */
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

a {
  text-decoration: none;
}
.v-snack:not(.v-snack--absolute) {
  position: absolute;
}

.theme--light.v-btn.v-btn--has-bg {
  background: #143652;
}

.v-dialog > .v-card > .v-card__text {
  padding: 0 24px;
}
</style>
